import { useMemo } from 'react'
import { parseGuestFromSmartParameterId } from '../../smart-parameters/helpers'
import { getLinkProductFeature } from '../helpers/product-feature'

export const useParsedGuest = ({
  smartParameterId,
  linkProductFeature,
}: {
  smartParameterId?: string | null
  linkProductFeature?: ReturnType<typeof getLinkProductFeature>
}) => {
  return useMemo(() => {
    // First try to parse from smart parameter
    const guestFromSmartParam = parseGuestFromSmartParameterId(smartParameterId)
    if (guestFromSmartParam) {
      return guestFromSmartParam
    }

    // Fallback to primaryGuestV2 email from linkProductFeature
    if (linkProductFeature?.primaryGuestV2?.email) {
      return {
        type: 'GuestEmailRequest' as const,
        guestEmail: linkProductFeature.primaryGuestV2.email,
      }
    }

    return undefined
  }, [smartParameterId, linkProductFeature])
}
